module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xabdo1-8b31b4e9c3286c9f0e862b0354d0b93c.jpg";